import { Pipe, PipeTransform } from '@angular/core';

import { TrackerStatusService } from '../services/trackerstatus.service';
import { TrackerStatus } from '../entities/index';

@Pipe({
  name: 'trackerStatusIdToName'
})
export class TrackerStatusIdToNamePipe implements PipeTransform {
  constructor(protected trackerStatusService: TrackerStatusService) {}

  transform(value: number): Promise<string> {
    return this.trackerStatusService.getAll()
                                    .then((statuses: TrackerStatus[]) => {
                                      return statuses.find((status: TrackerStatus) => status.id === value);
                                    })
                                    .then(status => status.code || 'n/a');
  }
}



// WEBPACK FOOTER //
// /app/src/app/pipes/trackerstatus-id-to-name.pipe.ts